// extracted by mini-css-extract-plugin
export default {"button":"guest_button__2sI91","deleteIcon":"guest_deleteIcon__KqKXj"};